import React from "react"
import { H2, P2 } from "components/Typography"
import a16zLogo from "./andreesen-horowitz.png"
import fathomLogo from "./fathom-capital.png"
import * as css from "./InvestorsSection.module.css"
import redPointLogo from "./redpoint.png"
import Section from "components/Layout/Section"

function InvestorsSection() {
  return (
    <Section className={css.root}>
      <div className={css.content}>
        <H2>Investors</H2>
        <P2>
          Preset is funded by Andreessen Horowitz, Fathom Capital, and Redpoint
          Ventures
        </P2>
        <div className={css.gridImage}>
          <img className="h-16" src={a16zLogo} alt="Andreesen Horowitz" />
          <img className="h-16" src={fathomLogo} alt="Fathom Captial" />
          <img className="h-16" src={redPointLogo} alt="Redpoint" />
        </div>
      </div>
    </Section>
  )
}

export default InvestorsSection
